import { useState } from "react";
import { EyeIcon } from "components/Icons/EyeIcon";
import { EyeClosedIcon } from "components/Icons/EyeClosedIcon";

export const OTPInput = ({
  value,
  onChange,
  prefix = "6-digit code",
  maxLength = 6,
  placeholder = "••••••",
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  
  const handleChange = (e) => {
    const value = e.target.value;
    if (value.length <= maxLength) {
      onChange?.(value);
    }
  };
  
  return (
    <div className="opt-input-wrapper w-full flex items-center justify-center border-[#0000004D] border-[1px] rounded-[10px] px-6 h-[60px]">
      <div className="flex-1">
        <div className="opt-input-prefix text-[12px] text-[#535353]">
          {prefix}
        </div>
        <input
          type={showPassword ? "tel" : "password"}
          value={value}
          onChange={handleChange}
          name="otp"
          maxLength={maxLength}
          className="tracking-[1rem] placeholder:text-black/30 font-bold text-xl"
          autoFocus
          autoComplete="off"
          placeholder={placeholder}
        />
      </div>
      <button className="opt-input-suffix" onClick={toggleShowPassword}>
        {showPassword ? <EyeIcon /> : <EyeClosedIcon />}
      </button>
    </div>
  );
};
